import type { Route } from 'types';

import Login from './Login';

const routes: Route[] = [{ path: '/login', component: Login }];

export default routes;
